import React from 'react'
import { ReactComponent as LogIcon } from '../../common/icons/log_icon.svg'
import { Stack, Button, Typography } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'

export default function EmptyTrainingModulePage({ topicId: propTopicId, children }) {
  return (
    <Stack sx={styles.container} alignItems='center' justifyContent='center'>
      <Stack spacing={2} justifyContent='center' alignItems='center' sx={styles.content}>
        <LogIcon />
        <Typography sx={styles.title}>Build Your Training Module</Typography>
        <Typography sx={styles.description}>
          Your topic is empty. Start building a custom training module to tailor security education to your team's
          needs.
        </Typography>
        <>{children}</>
      </Stack>
    </Stack>
  )
}

export const styles = {
  container: {
    height: 'calc(100vh - 172px)'
  },
  content: {
    width: '510px',
    spacing: 2
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    fontFamily: 'Plus Jakarta Sans',
    color: '#1B1B26'
  },
  description: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 400,
    fontFamily: 'Plus Jakarta Sans',
    color: '#1B1B26'
  },
  button: {
    width: '100%',
    background: '#6123FF',
    borderRadius: '14px',
    fontFamily: 'Plus Jakarta Sans',
    fontSize: '16px',
    height: '40px',
    color: '#fff',
    textTransform: 'none',
    border: 'none',
    '&:hover': { background: '#1565c0' }
  }
}
